const toKop = value => Math.round((Number(value) || 0) * 100);

const NOT_BONUS_PAYABLE_TYPES = ["accessory", "sampler"];

export const isBonusPayable = product =>
  !!product && !NOT_BONUS_PAYABLE_TYPES.includes(product.type) && !product.isSample;

export const resolveBonusSpend = ({ requested, balance, payable, total }) => {
  const wanted = requested === Infinity ? Infinity : Math.floor(Number(requested) || 0);
  let spend = Math.min(wanted, Math.max(0, Math.floor(Number(balance) || 0)), Math.floor(toKop(payable) / 100));
  spend = Math.max(0, spend);

  const rest = toKop(total) - spend * 100;
  if (rest > 0 && rest < 100) spend -= 1;

  return Math.max(0, spend);
};

export const roundKop = value => toKop(value) / 100;

export const isPaymentNotRequired = data =>
  !!data && typeof data === "object" && (data.paymentRequired === false || data.payment_required === false);
